






import { defineComponent } from '@vue/composition-api';
import CommonFormWithDriverEditor from '@/components/Setting/CommonFormWithDriverEditor.vue';

const DriverInformation = defineComponent({
  components: {
    CommonFormWithDriverEditor,
  },
  // setup() {},
});

export default DriverInformation;
